module.exports = {
      id: "icon-twitter-usage",
      viewBox: "0 0 19.798 20.251",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-twitter",
      toString: function () {
        return this.url;
      }
    }